import {
  Route,
} from "react-router-dom";

import { DiStellarViewer } from "../areas/distellar/DiStellarViewer";
import { Error404Screen } from "../components-common/errors";
import { Page, PageTable } from '@components-common/layouts';
import { RootieView } from "./screens/RootieView";
import { safeMerge } from "../components-common/_utils/safe-merge";
import { component_defaults } from "@components-defaults";
import { toolbar_defaults } from "@components-defaults";
import { PublicLayout } from "@components-system/layouts";

export const withLayout = (layout:any, component:any) => {
    return <Route element={layout}>
    {component}
  </Route>
}

const t = safeMerge(component_defaults.screen.index as any, {
  cat: "screen",
  type: "index",
  route:   {
    id: "route_courses_index",
    label: 'Assignment details',
    to: '/tests/route',
    roles: [],
    protected: false
  } as any,

  view: {
    cat: "screen",
    type: "index",
    props: {
      title: "dsafasd",
      toolbar: toolbar_defaults.index,
      table: {
        columns: ["name", "description", "type", "valueDefault"],
        actions:["edit", "delete"],
        source:"/coursesms/courses"
      }

    } as any,
    children:[],
    Component: PageTable as any,
  } as any,
  components: {
    layout: "workspace"

  }
}) as any;

const custom = safeMerge(component_defaults.screen.index as any, {
  cat: "screen",
  type: "custom",
  route:   {
    id: "route_courses_details",
    label: 'Assignment details',
    to: '/tests/route1',
    roles: [],
    protected: false
  } as any,

  view: {
    cat: "screen",
    type: "index",
    props: {
      title: "dsafasd",
      toolbar: toolbar_defaults.index,
      table: {
        columns: ["name", "description", "type", "valueDefault"],
        actions:["edit", "delete"],
        source:"/coursesms/courses"
      }

    } as any,
    children:[],
    Component: Page as any,
  } as any,
  components: {
    layout: "workspace"

  }
}) as any;

const justComponent = t.view;
export const routes = [
  <Route path="viewers">
    <Route path="distellar" element={<DiStellarViewer />} />
  </Route>,
  <Route path="/t/s" element={<RootieView {...justComponent}></RootieView>} />,
  <Route path="/t/s1" element={<RootieView {...custom.view}></RootieView>} />,
  withLayout(<PublicLayout />,<Route path="*" element={<Error404Screen />} />)
];
